import { jsx as _jsx } from "react/jsx-runtime";
import classnames from 'classnames';
import { Children, cloneElement, useMemo, useState } from 'react';
import { AccordionItem } from './AccordionItem';
import { AccordionContext } from './AccordionContext';
const Accordion = ({ children, className, autoClose = true, onSelect, activeItemsIds = [], ...rest }) => {
    // add id for the accordion items
    const arrayChildren = Children.toArray(children).map((child, index) => {
        return cloneElement(child, {
            id: child.props?.id || `accordion-${index}`,
        });
    });
    const [activeItemId, setActiveItemId] = useState(activeItemsIds);
    const contextValue = useMemo(() => ({
        activeItemId,
        onSelect,
        autoClose,
        setActiveItemId,
    }), [activeItemId, onSelect, autoClose]);
    return (_jsx(AccordionContext.Provider, { value: contextValue, children: _jsx("div", { className: classnames(className, 'p-0 m-0 border-0 w-100 align-baseline'), ...rest, children: arrayChildren }) }));
};
Accordion.Item = AccordionItem;
export { Accordion };
